export enum CutType {
    Full = 'Full',
    Partial = 'Partial',
    FullDirect = 'FullDirect',
    PartialDirect = 'PartialDirect'
}